import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { getCorrectShift } from "./utils";

function ShiftNumberDisplay({ time_field_id }) {
  const [selectedTime, setSelectedTime] = useState("");
  const [shift, setShift] = useState("");

  useEffect(() => {
    const timeField = document.getElementById(time_field_id);
    const handleTimeChange = (event) => {
      setSelectedTime(event.target.value);
    };

    if (timeField) {
      timeField.addEventListener("change", handleTimeChange);
    }

    return () => {
      if (timeField) {
        timeField.removeEventListener("change", handleTimeChange);
      }
    };
  }, [time_field_id]);

  useEffect(() => {
    if (selectedTime !== "") {
      const [hour] = selectedTime.split(":");
      setShift(getCorrectShift(hour));
    }
  }, [selectedTime]);

  return (
    <div className="flex">
      <p id="shift_number_display_react_component">{shift}</p>
    </div>
  );
}

ShiftNumberDisplay.propTypes = {
  time_field_id: PropTypes.string
};

export default ShiftNumberDisplay;
